function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as v } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: t , size: l = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const c = v(), o = t !== null && t !== void 0 ? t : c ? e.colors.inverse : e.colors.neutralHigh, { skinName: i  } = n();
    return i.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M7.893 19.5c-.396 0-.752-.15-1.036-.448L2 13.898l4.857-5.23c.428-.448 1.108-.56 1.712-.297.572.264.965.787.965 1.386v1.532h6.429v2.914c.036.038.18.076.216.076l3.893-4.112-3.93-4.183a.723.723 0 00-.215.076v2.99H10.93c-.396 0-.712-.34-.712-.746 0-.41.324-.745.712-.745h3.569V6.026c0-.599.356-1.122.964-1.386.608-.263 1.284-.15 1.712.298L22 10.163l-4.857 5.154c-.428.448-1.108.561-1.712.297-.572-.263-.928-.787-.928-1.385v-1.457H8.069v-2.99a.496.496 0 00-.216-.075L3.96 13.889l3.893 4.112a.723.723 0 00.216-.075v-2.914h4.997c.396 0 .712.339.712.745 0 .406-.324.745-.712.745H9.497v1.457c0 .599-.356 1.122-.964 1.386a1.246 1.246 0 01-.64.155z"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M16.52 13.588c.11.05.224.075.34.075a.779.779 0 00.534-.21l4.21-4.148a.757.757 0 000-1.132l-4.21-4.179a.788.788 0 00-.871-.137.754.754 0 00-.437.683l-.014 1.824-2.905.003a1.2 1.2 0 00-1.201 1.201v2.32a1.2 1.2 0 001.201 1.201l2.902-.005.014 1.823a.758.758 0 00.437.68zm.67-2.883a.772.772 0 00-.768-.745c-.005 0-.008 0-.011-.002l-3.24.005a.081.081 0 01-.082-.081v-2.32a.08.08 0 01.081-.08l3.252-.003a.772.772 0 00.768-.746v-.01l.01-1.35 3.385 3.358L17.2 12.07l-.011-1.353v-.012zM7.136 20.21a.773.773 0 01-.535-.213l-4.207-4.174a.754.754 0 010-1.129l4.21-4.154a.793.793 0 01.874-.135c.27.13.434.39.437.681l.014 1.821 2.902-.005c.664 0 1.202.537 1.202 1.201v2.32c0 .663-.538 1.201-1.202 1.201l-2.907.006-.014 1.823a.754.754 0 01-.437.684.825.825 0 01-.337.073zm-.341-1.597l.01-1.347v-.011a.77.77 0 01.78-.746l3.238-.002a.081.081 0 00.081-.082v-2.319a.081.081 0 00-.081-.081l-3.238.005a.768.768 0 01-.78-.745v-.01l-.01-1.351-3.378 3.336 3.378 3.353z"
        })
    }));
}, g = s;
export { g as default };
